module.exports = __webpack_public_path__ + "static/media/traveller-support-mobile-outlined-v2.dcfc3bbe.svg";